module.exports = __webpack_public_path__ + "img/kep2-1.7e94208b.jpg";